/* eslint-disable react/require-default-props */
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { useCallback, useState } from 'react';
import { LinkedinShareButton, FacebookShareButton, EmailShareButton } from 'react-share';

import { useTrackInteraction } from '../../hooks/useTracking';
import copyToClipboard from '../../lib/copyToClipboard';

import Button from '../buttons/Button';
import EmailIcon from '../icons/Email';
import FacebookIcon from '../icons/Facebook';
import InfoIcon from '../icons/Info';
import LinkIcon from '../icons/Link';
import LinkedinIcon from '../icons/LinkedIn';
import ShareIcon from '../icons/Share';

import styles from '../../styles/partials/share.module.css';

const body = `L’année 2024 n’a pas été de tout repos, n’est-ce pas?\n
Pas de panique, j’ai votre back. Voici un petit cadeau signé URBANIA qui devrait vous permettre de repartir du bon pied.\n
Car en 2025, il est enfin temps de passer à autre chose.\n
Repartez à neuf et laissez tout ce qui vous a fait @%Y%?*(&$%?2 dans les cendres du passé.\n
Comment? En passant au feu tous ce qui vous a fait sacrer (et plus encore) dans la dernière année.\n
Une véritable expérience thérapeutique (et un peu pyromane).\n
C'est ici: https://fetes2024.urbania.media \n
Partagez-la à vos collègues qui ne l'ont pas eu facile cette année, ils-elles le méritent.\n
De la part de toute l’équipe d’URBANIA, on vous souhaite un temps des fêtes léger et agréable, et on vous dit à l’année prochaine.\n
`;

const propTypes = {
    onClickInfo: PropTypes.func,
    onClickShare: PropTypes.func,
    withoutInfo: PropTypes.bool,
    withoutShare: PropTypes.bool,
    visible: PropTypes.bool,
    className: PropTypes.string,
};

function Share({
    onClickInfo = null,
    onClickShare = null,
    withoutInfo = false,
    withoutShare = false,
    visible: initialVisible = false,
    className = null,
}) {
    const [visible, setVisible] = useState(initialVisible);
    const [linkCopied, setLinkCopied] = useState(false);
    const [url] = useState(window.location.href);

    const trackInteraction = useTrackInteraction();

    const onClickVisible = useCallback(() => {
        setVisible(!visible);

        if (onClickShare !== null) {
            onClickShare();
        }
    }, [visible, setVisible, onClickShare]);

    const onClickCopy = useCallback(
        (e) => {
            e.preventDefault();
            e.stopPropagation();
            copyToClipboard(url).then(() => {
                setLinkCopied(true);
                setTimeout(() => {
                    setLinkCopied(false);
                }, 2000);
            });
            if (trackInteraction !== null) {
                trackInteraction('share', 'click', 'copy_link');
            }
        },
        [url, setLinkCopied, trackInteraction],
    );

    const onShareButtonClick = useCallback(
        (type) => {
            if (trackInteraction !== null) {
                trackInteraction('share', 'click', type || 'empty');
            }
        },
        [trackInteraction],
    );

    return (
        <div
            className={classNames([
                styles.container,
                { [styles.visible]: visible, [className]: className !== null },
            ])}
        >
            <LinkedinShareButton
                className={styles.icon}
                url={url}
                title={document.title}
                beforeOnClick={() => {
                    onShareButtonClick('LinkedIn');
                    return Promise.resolve();
                }}
            >
                <LinkedinIcon />
            </LinkedinShareButton>
            <FacebookShareButton
                className={styles.icon}
                url={url}
                title={document.title}
                beforeOnClick={() => {
                    onShareButtonClick('Facebook');
                    return Promise.resolve();
                }}
            >
                <FacebookIcon />
            </FacebookShareButton>
            <EmailShareButton
                className={styles.icon}
                url=""
                subject="Un cadeau de la part d’URBANIA - Je pense que ça vous fera du bien 💌"
                body={body}
                beforeOnClick={() => {
                    onShareButtonClick('Email');
                    return Promise.resolve();
                }}
            >
                <EmailIcon />
            </EmailShareButton>
            <Button className={classNames([styles.icon, styles.copyButton])} onClick={onClickCopy}>
                <LinkIcon />
                <div className={styles.labelText}>
                    {linkCopied ? <span>Lien copié!</span> : null}
                </div>
            </Button>
            {!withoutShare ? (
                <Button
                    className={classNames([styles.icon, styles.visibleButton])}
                    onClick={onClickVisible}
                >
                    <ShareIcon />
                </Button>
            ) : null}

            {!withoutInfo ? (
                <Button
                    className={classNames([styles.icon, styles.infoButton])}
                    onClick={onClickInfo}
                >
                    <InfoIcon />
                </Button>
            ) : null}
        </div>
    );
}

Share.propTypes = propTypes;

export default Share;
